import AllContainers from "barcelo-components/containers";
import AdvComponents from "barcelo-components/adv";
import StructureComponents from "barcelo-components/structure";
import HotelComponents from "barcelo-components/hotel";
import GenericComponents from "barcelo-components/generic";
import ListingComponents from "barcelo-components/listing";
import MenuComponents from "barcelo-components/menu";
import VariousComponents from "barcelo-components/various";
import TeasersComponents from "barcelo-components/teasers";
import FaqComponents from "barcelo-components/faq";
import MyBarceloComponents from "barcelo-components/mybarcelo";

const { container, swiper, accordion, tabsdropdown, tabMenu, launchersContainer } = AllContainers;
const { ribbon, languageRibbon, translationEnabledLanguageDialog } = AdvComponents;
const {
  brands,
  megaMenu,
  asideMenu,
  sticky,
  language,
  phoneCC,
  header,
  heroslider,
  hotelMeetingRooms,
  hotelRoyal,
  calendar,
  destination,
  discount,
  highlightsGallery,
  awardsSwiper,
  rooms,
  fastbooking,
  customModal,
  headerDetail,
  campaignGenericComponentGroup,
  localeConfigurationForm,
  footer,
  headHotelInfo,
} = StructureComponents;
const { hotelRelated, weather, dorintHotelCards, hotelHighlights } = HotelComponents;
const { cta, socialSharing, filePicker } = GenericComponents;
const { feedEntries, cardHotelList, collectionsListing, offerDestination, promoList, swiperCollectionList, campaignList } = ListingComponents;
const { stripeMenu, vMenu } = MenuComponents;
const { languageDialog, currencyDialog, profilingWizardItem, profWizard, opinion, phoneContact, socialRoom, interactiveMap, customChrono, carouselExtras } = VariousComponents;
const { carousel, coupon, servicesCarousel, card, launcher, menuCards, experienceCards, gallerySummary } = TeasersComponents;
const { faq, widgetFaq } = FaqComponents;
const { mybOpinion, mybTriggerBanner, mybLoyaltyHero, mybLoyaltyInfo, mybBanner } = MyBarceloComponents;

// Verifica si la URL actual es 'reservation.barcelo.com'
const isReservationBarcelo = window.location.hostname === "reservation.barcelo.com";

// Objeto base con todos los componentes
const allComponents = {
  header,
  heroslider,
  ribbon,
  swiper,
  headHotelInfo,
  campaignList,
  sticky,
  container,
  destination,
  calendar,
  discount,
  rooms,
  cta,
  campaignGenericComponentGroup,
  vMenu,
  megaMenu,
  asideMenu,
  headerDetail,
  stripeMenu,
  phoneCC,
  footer,
  fastbooking,
  accordion,
  tabsdropdown,
  language,
  languageRibbon,
  translationEnabledLanguageDialog,
  brands,
  hotelMeetingRooms,
  hotelRoyal,
  awardsSwiper,
  highlightsGallery,
  customModal,
  localeConfigurationForm,
  hotelRelated,
  weather,
  socialSharing,
  feedEntries,
  cardHotelList,
  collectionsListing,
  offerDestination,
  promoList,
  swiperCollectionList,
  languageDialog,
  currencyDialog,
  profilingWizardItem,
  profWizard,
  opinion,
  phoneContact,
  socialRoom,
  interactiveMap,
  customChrono,
  carouselExtras,
  carousel,
  coupon,
  servicesCarousel,
  card,
  launcher,
  faq,
  tabMenu,
  widgetFaq,
  mybOpinion,
  mybTriggerBanner,
  dorintHotelCards,
  hotelHighlights,
  menuCards,
  mybLoyaltyHero,
  mybLoyaltyInfo,
  experienceCards,
  gallerySummary,
  launchersContainer,
  mybBanner,
  filePicker,
};

// Si estamos en 'reservation.barcelo.com', eliminamos los componentes que no queremos exportar
if (isReservationBarcelo) {
  const componentsToExclude = ["carouselExtras", "footer", "fastbooking", "feedEntries", "brands", "destination", "header"];
  componentsToExclude.forEach((component) => {
    delete allComponents[component];
  });
}

export default allComponents;
